exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n/*@import \"../node_modules/materialize-css/dist/css/materialize.css\";*/\n\n.ng2pagination .ng2-pagination .current {\n  background: #607d8b;\n}\n\n.accordion-header {\n  text-transform: uppercase;\n}\n\n.navbar-fixed { \n  z-index: 9999; \n}\n\n/* Needed otherwise tables have default font style.  Not sure why though... */\ntable {\n  font-family: 'Roboto', sans-serif;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/mark/Documents/Source/MachineResearch/MR2/angular2/node_modules/postcss-loader?{"ident":"postcss"}!/Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles